var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 55,
    viewBox: "0 0 28 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 18,
    height: 45,
    rx: 2,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.79701 27.5L14.4622 21.5393C14.5343 21.4479 14.4693 21.3125 14.3515 21.3125H12.9927C12.9066 21.3125 12.824 21.3529 12.7712 21.4197L8.28354 27.1537C8.20582 27.2527 8.16357 27.375 8.16357 27.5009C8.16357 27.6268 8.20582 27.749 8.28354 27.848L12.7712 33.5803C12.824 33.6488 12.9066 33.6875 12.9927 33.6875H14.3515C14.4693 33.6875 14.5343 33.5521 14.4622 33.4607L9.79701 27.5ZM15.1408 27.5L19.806 21.5393C19.8781 21.4479 19.813 21.3125 19.6953 21.3125H18.3365C18.2503 21.3125 18.1677 21.3529 18.115 21.4197L13.6273 27.1537C13.5496 27.2527 13.5073 27.375 13.5073 27.5009C13.5073 27.6268 13.5496 27.749 13.6273 27.848L18.115 33.5803C18.1677 33.6488 18.2503 33.6875 18.3365 33.6875H19.6953C19.813 33.6875 19.8781 33.5521 19.806 33.4607L15.1408 27.5Z",
    fill: "#828282"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 28,
    height: 55,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandButton);
export default __webpack_public_path__ + "static/media/expand-button.bffbe01f59cb5e0b82cb772d801db7a9.svg";
export { ForwardRef as ReactComponent };